import { Injectable } from '@angular/core';

import { Inventario, ProductoAPI } from '../../../../models/reposicion.model';

@Injectable({
  providedIn: 'root'
})
export class TablaMedicamentosService {
  agruparProductos(productos: ProductoAPI[]): ProductoAPI[] {
    const mapa = new Map<string, ProductoAPI>();

    productos.forEach((p) => {
      const existente = mapa.get(p.productId);

      if (!existente) {
        mapa.set(p.productId, {
          ...p,
          stock: p.stock ?? 0
        });
      } else {
        existente.stock += p.stock ?? 0;
      }
    });

    return Array.from(mapa.values());
  }

  construirInventario(
    productos: ProductoAPI[],
    sucursales: string[],
    inventarioGuardado: Inventario[]
  ): Map<string, Inventario> {
    const inventarioMap = new Map<string, Inventario>();

    const inventarioIndex = new Map<string, Inventario>();

    inventarioGuardado.forEach((i) => {
      const key = `${i.productId}-${i.sucursalCodigo}`;

      inventarioIndex.set(key, i);
    });

    sucursales.forEach((sucursal) => {
      productos.forEach((p) => {
        const key = `${p.productId}-${sucursal}`;

        const existente = inventarioIndex.get(key);

        inventarioMap.set(key, {
          medicamentoCodigo: p.productCode,
          productId: p.productId,
          sucursalCodigo: sucursal,
          format: p.format,
          stock: p.stock ?? 0,
          cantidad: existente?.cantidad ?? 0
        });
      });
    });

    return inventarioMap;
  }

  construirStockMap(productos: ProductoAPI[]): Map<string, number> {
    const stockMap = new Map<string, number>();

    productos.forEach((p) => {
      stockMap.set(p.productId, p.stock ?? 0);
    });

    return stockMap;
  }
}
